import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '@/assets/overrideNg.css'

NProgress.configure({
  minimum: 0.2,
  showSpinner: false,
})

const useRouteLoading = () => {
  const start = () => NProgress.start()

  const stop = () => NProgress.done()

  return {
    stop,
    start,
  }
}

export default useRouteLoading
